import { ACHIEVEMENTS as DEFAULT_ACHIEVEMENTS } from "./achievement";
import { getThemeAchievementImages } from "../models/theme";

const themeCfg = JSON.parse(import.meta.env.VITE_THEME_CFG ?? "{}");
const overrideSet = new Set<string>(themeCfg.overrideAchievementIcons ?? []);

export const ACHIEVEMENTS = overrideSet.size
  ? DEFAULT_ACHIEVEMENTS.map((achievement) => {
      const override = overrideSet.has(achievement.id)
        ? getThemeAchievementImages(achievement.id)
        : undefined;
      return override ? { ...achievement, icons: override } : achievement;
    })
  : DEFAULT_ACHIEVEMENTS;

export {
  ACHIEVEMENTS_BG_COLORS,
  ACHIEVEMENTS_ORDER,
  PRODUCT_QUERY,
} from "./achievement";
